<template>
  <header class="top-header" v-bind:class="{ 'on-home': isHome }">
    <transition
      v-on:before-enter="headingBeforeEnter"
      v-on:enter="headingEnter"
      appear
    >
      <div class="header-content-wrapper">
        <div id="logo">
          <router-link to="/"><img class="logo" src="../assets/logo.svg" alt=""></router-link>
        </div>
        <button class="hamburger hamburger--collapse" v-on:click="isActive = !isActive" :class="{ 'is-active': isActive }" type="button">
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>
        </button>
        <nav class="top-header-nav" :class="{ 'active': isActive }">
          <ul>
            <li><router-link v-on:click.native="isActive = false" to="/services">Services</router-link></li>
            <li><router-link v-on:click.native="isActive = false" to="/about-us">About us</router-link></li>
            <li><router-link v-on:click.native="isActive = false" to="/our-approach">Our approach</router-link></li>
            <li><router-link v-on:click.native="isActive = false" to="/contact">Contact</router-link></li>
          </ul>
        </nav>
      </div>
    </transition>
  </header>
</template>

<script>
import Velocity from 'velocity-animate'

export default {
  name: 'TopHeader',

  data () {
    return {
      isActive: false
    }
  },

  computed: {
    isHome () {
      if (this.$route.name === 'Home') return true
      return false
    }
  },

  methods: {
    headingBeforeEnter (el) {
      el.style.opacity = 0
    },

    headingEnter (el, done) {
      Velocity(el, { opacity: 1 }, { duration: 1000, delay: 2000 })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TopHeader.vue